import configData from "config/schemaConfiguration.json";

export const ProductSchema = (product, store = "gatco") => {
  const schemaConfiguration = configData[store];

  const data = product && {
    "@context": "https://schema.org/",
    "@type": "Product",
    name: product.name,
    image: product?.small_image && product.small_image?.url,
    sku: product.sku,
    mpn: product.id,
    url: schemaConfiguration.url + product.url_key,
    description: product.description && product.description.html,
    brand: {
      "@type": "Thing",
      name: schemaConfiguration.name,
    },
    offers: {
      "@type": "Demand",
      seller: {
        "@type": "Organization",
        name: schemaConfiguration.name,
      },
    },
  };

  return JSON.stringify(data);
};
